module.exports = __webpack_public_path__ + "static/media/iot.040dac7d.jpg";